import {Injectable} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {constants} from '@q9elements/ui-kit/common';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

const DEFAULT_PAGE_INDEX = constants.pagination.skipDefault;
const DEFAULT_PAGE_SIZE = constants.pagination.nodesPerPageDefault;
const DEFAULT_PAGE_SIZE_OPTIONS = constants.pagination.pageSizeOptions;

@Injectable()
export class GridPagerService {
  private _pageIndex$ = new BehaviorSubject<number>(DEFAULT_PAGE_INDEX);
  private _pageSize$ = new BehaviorSubject<number>(DEFAULT_PAGE_SIZE);
  public pageSizeOptions$ = new BehaviorSubject<number[]>(DEFAULT_PAGE_SIZE_OPTIONS);
  public pageIndex$ = this._pageIndex$.pipe(distinctUntilChanged());
  public pageSize$ = this._pageSize$.pipe(distinctUntilChanged());
  public skip$ = combineLatest([this.pageIndex$, this.pageSize$]).pipe(
    map(([pageIndex, pageSize]) => pageIndex * pageSize)
  );

  public reset(): void {
    this._pageIndex$.next(DEFAULT_PAGE_INDEX);
    this._pageSize$.next(DEFAULT_PAGE_SIZE);
  }

  public resetPageIndex(): void {
    this._pageIndex$.next(DEFAULT_PAGE_INDEX);
  }

  public handlePageChange({pageIndex, pageSize}: PageEvent): void {
    this._pageSize$.next(pageSize);
    this._pageIndex$.next(pageIndex);
  }

  public getPageSizeAndIndex(): PageEvent {
    const pageSize = this._pageSize$.getValue();
    const pageIndex = this._pageIndex$.getValue();

    return {pageSize, pageIndex} as PageEvent;
  }

  public changePageSizes(pageSizes: number[]) {
    this.pageSizeOptions$.next(pageSizes);
  }

  public setDefaultPageSize(pageSize: number) {
    this._pageSize$.next(pageSize);
  }

  public setDefaultPageIndex(pageIndex: number) {
    this._pageIndex$.next(pageIndex);
  }
}
